module.exports = __webpack_public_path__ + "fonts/icomoon.85af5563.woff";